import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { FileUploadData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<FileUploadData>;
};

export const FileUploadModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
